module.exports = __webpack_public_path__ + "static/media/portfolio.1230b78e.svg";